import '../../css/style.scss';
import { UIWHeaderController } from '../ui_html/header/UIWHeaderController.ts';
import { UISidebarController } from '../ui_html/sidebar/UISidebarController.ts';
import { EntryShared } from '../../../shared/scripts/EntryShared.ts';
import { EntrySingletonPageShared } from '../../EntrySingletonPageShared.ts';
import { UIChampionship25Controller } from '../../../shared/scripts/ui_cc/UIChampionship25Controller.ts';
void init();
async function init() {
    EntryShared.initializeAudio();
    await EntryShared.initializeEntry();
    const headerController = new UIWHeaderController();
    new UISidebarController();
    new UIChampionship25Controller();
    EntrySingletonPageShared.initializeSocketAndGeneralServices(headerController);
    EntryShared.sendPageVisitAnalyticEvent();
}
